export default __webpack_public_path__ + "static/media/Fall_14.a2278935.png";